import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.4",
  "description": "Turborepo 1.4 has new examples, automatically includes environment variables, and more!",
  "date": "2022/08/09",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.4 brings:"
  }, {
    "heading": "",
    "content": "Automatic environment variable inclusion: We'll automatically infer popular framework environment variables for you. No need to declare them yourself in turbo.json."
  }, {
    "heading": "",
    "content": "eslint-config-turbo: Enhanced feedback with a new ESLint plugin."
  }, {
    "heading": "",
    "content": "New framework and library examples: New starters and examples requested by the community."
  }, {
    "heading": "",
    "content": "Update today by running npm install turbo@latest."
  }, {
    "heading": "automatic-environment-variable-inclusion",
    "content": "To help ensure correct caching across environments Turborepo will now automatically infer and include public environment variables when calculating cache keys for apps built with Astro, Create React App, Gatsby, Next.js, Nuxt, SvelteKit, Vite, Vue, and more. You can safely remove framework-specific public environment variables from turbo.json if you manually declared them."
  }, {
    "heading": "automatic-environment-variable-inclusion",
    "content": "Note that this automatic detection and inclusion only works if Turborepo successfully infers the framework your apps are built with. Additionally, the environment variables will only be included in the cache key for tasks in workspaces where that framework is used. In other words, environment variables inferred for Next.js apps, will only be included in the cache key for workspaces detected as Next.js apps. Tasks in other workspaces in the monorepo will not be impacted."
  }, {
    "heading": "automatic-environment-variable-inclusion",
    "content": "For example, consider a monorepo with three workspaces: a Next.js project, a Create React App project, and a TypeScript package. Each has a build script, and both apps depend on the TypeScript project. Let's say that this Turborepo has a standard turbo.json pipeline that builds them all in order:"
  }, {
    "heading": "automatic-environment-variable-inclusion",
    "content": "As of 1.4, when you run turbo run build, Turborepo will not consider any build time environment variables relevant when building the TypeScript package. However, when building the Next.js app, Turborepo will infer that environment variables starting with NEXT_PUBLIC_ could alter the output of the .next folder and should thus be included when calculating the hash. Similarly, when calculating the hash of the Create React App's build script, all build time environment variables starting with REACT_APP_PUBLIC_ will be included."
  }, {
    "heading": "automatic-environment-variable-inclusion",
    "content": "This improvement in hash specificity by framework is a significant step toward optimal, safe, and correct caching."
  }, {
    "heading": "eslint-config-turbo",
    "content": "We've also created a new ESLint config for further in-editor assistance to help ensure your Turborepo cache can be correctly shared across every environment. While our new hashing algorithm should cover most situations with most frameworks, this ESLint config will provide in-editor feedback for teams using other build time inlined environment variables that are not framework-prefixed but impact build outputs (i.e. caching), and teams using their own in-house frameworks that we cannot detect automatically."
  }, {
    "heading": "eslint-config-turbo",
    "content": "To get started, extend from eslint-config-turbo in your root eslintrc file:"
  }, {
    "heading": "eslint-config-turbo",
    "content": "If you prefer more control over the rules - use can install and configure the eslint-plugin-turbo plugin directly by first adding it to plugins and then configuring the desired rules:"
  }, {
    "heading": "eslint-config-turbo",
    "content": "The plugin will warn you if you are using non-framework-related environment variables in your code that have not been declared in your turbo.json."
  }, {
    "heading": "eslint-config-turbo",
    "content": "As of 1.4.x, we now include eslint-config-turbo in all of our examples and in new projects generated via npx create-turbo."
  }, {
    "heading": "eslint-config-turbo",
    "content": "Learn more about ESLint configs and plugins in the ESLint docs."
  }, {
    "heading": "new-framework-and-library-examples",
    "content": "Based on your feedback and suggestions, we've created new examples to integrate Turborepo into your workflow:"
  }, {
    "heading": "new-framework-and-library-examples",
    "content": "Svelte"
  }, {
    "heading": "new-framework-and-library-examples",
    "content": "Docker"
  }, {
    "heading": "new-framework-and-library-examples",
    "content": "React Native"
  }, {
    "heading": "new-framework-and-library-examples",
    "content": "Prisma"
  }, {
    "heading": "new-framework-and-library-examples",
    "content": "Tailwind"
  }, {
    "heading": "new-framework-and-library-examples",
    "content": "… and more!"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "Allow both sides of git comparison (#1442)"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "Properly rebuild packages that share a name prefix (#1538)"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "Cache files with the correct file permissions (#1429)"
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo v1.3 in June, we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "8.65k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "365k weekly NPM downloads, up 2x since late April"
  }, {
    "heading": "community",
    "content": "10 years of compute time saved through Remote Caching on Vercel, saving 10 months per week"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of our contributors including our core team."
  }, {
    "heading": "community",
    "content": "This release was brought to you by the contributions of: @B2o5T, @chitchu, @elis, @gsoltis, @harshcut, @jaredpalmer, @kocisov, @nathanhammond, @neolivz, @NuroDev, @oneezy, @samouri, @shayc, @StevenMatchett, @tknickman, @trevorr, @zsoldosp, and more!"
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "automatic-environment-variable-inclusion",
    "content": "Automatic environment variable inclusion"
  }, {
    "id": "eslint-config-turbo",
    "content": "eslint-config-turbo"
  }, {
    "id": "new-framework-and-library-examples",
    "content": "New framework and library examples"
  }, {
    "id": "other-bug-fixes-and-improvements",
    "content": "Other bug fixes and improvements"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#automatic-environment-variable-inclusion",
  title: _jsx(_Fragment, {
    children: "Automatic environment variable inclusion"
  })
}, {
  depth: 2,
  url: "#eslint-config-turbo",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "eslint-config-turbo"
    })
  })
}, {
  depth: 2,
  url: "#new-framework-and-library-examples",
  title: _jsx(_Fragment, {
    children: "New framework and library examples"
  })
}, {
  depth: 2,
  url: "#other-bug-fixes-and-improvements",
  title: _jsx(_Fragment, {
    children: "Other bug fixes and improvements"
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.4"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, August 9th, 2022"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.4 brings:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#automatic-environment-variable-inclusion",
          children: _jsx(_components.strong, {
            children: "Automatic environment variable inclusion:"
          })
        }), " We'll automatically infer popular framework environment variables for you. No need to declare them yourself in ", _jsx(_components.code, {
          children: "turbo.json"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#eslint-config-turbo",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "eslint-config-turbo"
            }), ":"]
          })
        }), " Enhanced feedback with a new ESLint plugin."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-framework-and-library-examples",
          children: _jsx(_components.strong, {
            children: "New framework and library examples:"
          })
        }), " New starters and examples requested by the community."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "automatic-environment-variable-inclusion",
      children: "Automatic environment variable inclusion"
    }), "\n", _jsxs(_components.p, {
      children: ["To help ensure correct caching across environments Turborepo will now automatically infer and include public environment variables when calculating cache keys for apps built with Astro, Create React App, Gatsby, Next.js, Nuxt, SvelteKit, Vite, Vue, and more. You can safely remove framework-specific public environment variables from ", _jsx(_components.code, {
        children: "turbo.json"
      }), " if you manually declared them."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      \"dependsOn\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "        \"^build\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // Include build time public inlined environment variables that"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // are different in development and production, so that"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // Turborepo does not use the same cached build"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       // across environments"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       \"$NEXT_PUBLIC_EXAMPLE_ENV_VAR\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Note that this automatic detection and inclusion only works if Turborepo successfully infers the framework your apps are built with. Additionally, the environment variables will only be included in the cache key for tasks in workspaces where that framework is used. In other words, environment variables inferred for Next.js apps, will only be included in the cache key for workspaces detected as Next.js apps. Tasks in other workspaces in the monorepo will not be impacted."
    }), "\n", _jsxs(_components.p, {
      children: ["For example, consider a monorepo with three workspaces: a Next.js project, a Create React App project, and a TypeScript package. Each has a ", _jsx(_components.code, {
        children: "build"
      }), " script, and both apps depend on the TypeScript project. Let's say that this Turborepo has a standard ", _jsx(_components.code, {
        children: "turbo.json"
      }), " pipeline that builds them all in order:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["As of 1.4, when you run ", _jsx(_components.code, {
        children: "turbo run build"
      }), ", Turborepo will not consider any build time environment variables relevant when building the TypeScript package. However, when building the Next.js app, Turborepo will infer that environment variables starting with ", _jsx(_components.code, {
        children: "NEXT_PUBLIC_"
      }), " could alter the output of the ", _jsx(_components.code, {
        children: ".next"
      }), " folder and should thus be included when calculating the hash. Similarly, when calculating the hash of the Create React App's ", _jsx(_components.code, {
        children: "build"
      }), " script, all build time environment variables starting with ", _jsx(_components.code, {
        children: "REACT_APP_PUBLIC_"
      }), " will be included."]
    }), "\n", _jsx(_components.p, {
      children: "This improvement in hash specificity by framework is a significant step toward optimal, safe, and correct caching."
    }), "\n", _jsx(_components.h2, {
      id: "eslint-config-turbo",
      children: _jsx(_components.code, {
        children: "eslint-config-turbo"
      })
    }), "\n", _jsx(_components.p, {
      children: "We've also created a new ESLint config for further in-editor assistance to help ensure your Turborepo cache can be correctly shared across every environment. While our new hashing algorithm should cover most situations with most frameworks, this ESLint config will provide in-editor feedback for teams using other build time inlined environment variables that are not framework-prefixed but impact build outputs (i.e. caching), and teams using their own in-house frameworks that we cannot detect automatically."
    }), "\n", _jsxs(_components.p, {
      children: ["To get started, extend from ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " in your root ", _jsx(_components.a, {
        href: "https://eslint.org/docs/latest/user-guide/configuring/configuration-files#configuration-file-formats",
        children: _jsx(_components.code, {
          children: "eslintrc"
        })
      }), " file:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".eslint.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // Automatically flag env vars missing from turbo.json"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"next/core-web-vitals\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If you prefer more control over the rules - use can install and configure the ", _jsx(_components.code, {
        children: "eslint-plugin-turbo"
      }), " ", _jsx(_components.em, {
        children: "plugin"
      }), " directly by first adding it to plugins and then configuring the desired rules:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".eslint.config.js",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"next/core-web-vitals\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"plugins\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"turbo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"rules\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // Automatically flag env vars missing from turbo.json"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"turbo/no-undeclared-env-vars\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"error\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The plugin will warn you if you are using non-framework-related environment variables in your code that have not been declared in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["As of 1.4.x, we now include ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " in all of our examples and in new projects generated via ", _jsx(_components.code, {
        children: "npx create-turbo"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Learn more about ESLint configs and plugins in the ", _jsx(_components.a, {
        href: "https://eslint.org/docs/latest/",
        children: "ESLint docs"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "new-framework-and-library-examples",
      children: "New framework and library examples"
    }), "\n", _jsx(_components.p, {
      children: "Based on your feedback and suggestions, we've created new examples to integrate Turborepo into your workflow:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-svelte",
          children: "Svelte"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-docker",
          children: "Docker"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-react-native-web",
          children: "React Native"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-prisma",
          children: "Prisma"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples/with-tailwind",
          children: "Tailwind"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["… ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/tree/main/examples",
          children: "and more!"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "other-bug-fixes-and-improvements",
      children: "Other bug fixes and improvements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Allow both sides of git comparison (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/1442",
          children: "#1442"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Properly rebuild packages that share a name prefix (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/1538",
          children: "#1538"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Cache files with the correct file permissions (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/1429",
          children: "#1429"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "https://turborepo.com/blog/turbo-1-3-0",
        children: "Turborepo v1.3 in June"
      }), ", we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "8.65k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: "365k weekly NPM downloads, up 2x since late April"
      }), "\n", _jsx(_components.li, {
        children: "10 years of compute time saved through Remote Caching on Vercel, saving 10 months per week"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of our contributors including our core team."
    }), "\n", _jsx(_components.p, {
      children: "This release was brought to you by the contributions of: @B2o5T, @chitchu, @elis, @gsoltis, @harshcut, @jaredpalmer, @kocisov, @nathanhammond, @neolivz, @NuroDev, @oneezy, @samouri, @shayc, @StevenMatchett, @tknickman, @trevorr, @zsoldosp, and more!"
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
